/* Juwelier Benjamin: Shop-Anfragen.
   Seit 21.10.2026: Verlobung, Trauring, Produktfrage und Kontaktseite senden die Anfrage direkt als
   WhatsApp-Benachrichtigung ans Ladenhandy (Supabase-Funktion jb-anfrage-push, Vorlage jb_anfrage_mit_kontakt).
   Klappt das nicht, oeffnet sich wie bisher der vorbereitete WhatsApp-Chat, den der Kunde selbst absendet.
   Verfuegbarkeitsanfragen ohne Kontaktfelder bleiben beim Chat. Messung ohne Formularinhalte. */
(function () {
  'use strict';
  var WA_NUMBER = '491774820580';
  var ZIEL = 'https://mtyzlbtdykvjddepaqnt.supabase.co/functions/v1/jb-anfrage-push';
  var START = Date.now();
  var tracking = window.JBTracking, vorgaenge = new WeakMap();
  if (!tracking) return;
  var ARTEN = ['verlobung', 'trauring', 'kontakt', 'produkt', 'verfuegbarkeit'];
  var DIREKT = { verlobung: 'Termin anfragen', trauring: 'Anfrage senden', produkt: 'Frage senden', kontakt: 'Anfrage senden' };
  var HINWEIS = {
    verlobung: 'Ihre Anfrage geht direkt per WhatsApp an das Ladenhandy von Juwelier Benjamin. Der Termin steht erst nach persönlicher Bestätigung.',
    trauring: 'Ihre Auswahl geht direkt per WhatsApp an das Ladenhandy von Juwelier Benjamin. Ein Termin oder Angebot gilt erst nach unserer persönlichen Bestätigung.',
    produkt: 'Ihre Frage geht direkt per WhatsApp an das Ladenhandy von Juwelier Benjamin.',
    kontakt: 'Ihre Anfrage geht direkt per WhatsApp an das Ladenhandy von Juwelier Benjamin.'
  };
  var DANKE = {
    verlobung: ' Der Termin steht erst nach persönlicher Bestätigung.',
    trauring: ' Ein Termin oder Angebot gilt erst nach unserer persönlichen Bestätigung.'
  };
  var labels = {
    Modell: 'Modell', Kollektion: 'Kollektion', Farbwunsch: 'Goldfarbe',
    Legierung: 'Legierung', Steinbesatz: 'Steine', Ringgroesse_1: 'Ringgröße 1',
    Ringgroesse_2: 'Ringgröße 2', Gravur_1: 'Gravur 1', Gravur_2: 'Gravur 2',
    Preis_je_Ring: 'Preis je Ring', Preis_Paar: 'Preis Paar',
    Wunschtermin: 'Wunschtermin', Hochzeit: 'Hochzeitsdatum',
    Konfiguration_Link: 'Konfiguration'
  };
  function field(form, name, max) {
    var control = form.elements.namedItem('contact[' + name + ']');
    if (!control || control.disabled || typeof control.value !== 'string') return '';
    return control.value.trim().replace(/\s+/g, ' ').slice(0, max || 180);
  }
  function box(button, attr, role) {
    var el = button.parentNode.querySelector('[' + attr + ']');
    if (!el) {
      el = document.createElement('p');
      el.setAttribute(attr, '');
      el.setAttribute('role', role);
      button.insertAdjacentElement('afterend', el);
    }
    el.hidden = false;
    return el;
  }
  function error(button, message, control) {
    box(button, 'data-jb-wa-error', 'alert').textContent = message;
    if (control) control.focus();
  }
  function requireField(form, button, name, message) {
    if (field(form, name)) return true;
    error(button, message, form.elements.namedItem('contact[' + name + ']'));
    return false;
  }
  function add(lines, title, value) { if (value) lines.push(title + ': ' + value); }
  function message(form, kind) {
    var lines = ['Hallo Juwelier Benjamin, ich möchte eine Anfrage stellen.'];
    var title = { verlobung: 'Verlobungsring-Beratung', trauring: 'Trauring-Konfiguration', kontakt: 'Allgemeine Anfrage', produkt: 'Produktfrage', verfuegbarkeit: 'Verfügbarkeit eines Produkts' }[kind];
    add(lines, 'Anliegen', title);
    add(lines, 'Name', field(form, 'name', 100));
    add(lines, 'Telefon', field(form, 'phone', 40));
    add(lines, 'E-Mail', field(form, 'email', 180));
    if (kind === 'verlobung') {
      add(lines, 'Wunschtermin', field(form, 'Wunschtermin'));
      add(lines, 'Ringform', field(form, 'Ringform'));
      add(lines, 'Goldfarbe', field(form, 'Goldfarbe'));
      add(lines, 'Budget', field(form, 'Budget'));
      add(lines, 'Gutschein', field(form, 'Gutschein'));
    } else if (kind === 'trauring') {
      Object.keys(labels).forEach(function (key) { add(lines, labels[key], field(form, key, key === 'Konfiguration_Link' ? 900 : 180)); });
    } else if (kind === 'produkt' || kind === 'verfuegbarkeit') {
      add(lines, 'Produkt', field(form, 'ProductURL', 900) || field(form, 'product_url', 900) || location.origin + location.pathname);
    }
    add(lines, 'Nachricht', field(form, 'body', 900) || field(form, 'message', 900));
    return lines.join('\n');
  }
  // Kurzfassung fuer die WhatsApp-Benachrichtigung ans Ladenhandy (Grenzen setzt zusaetzlich der Server).
  function anfrage(form, kind) {
    var details = [], termin = [], nachricht = [];
    function d(list, title, value) { if (value) list.push(title ? title + ': ' + value : value); }
    if (kind === 'verlobung') {
      d(details, 'Ringform', field(form, 'Ringform', 40));
      d(details, 'Goldfarbe', field(form, 'Goldfarbe', 30));
      d(details, 'Budget', field(form, 'Budget', 40));
      d(details, 'Vorteil', field(form, 'Gutschein', 30));
      d(termin, '', field(form, 'Wunschtermin', 60));
    } else if (kind === 'trauring') {
      ['Modell', 'Kollektion', 'Farbwunsch', 'Legierung', 'Steinbesatz', 'Ringgroesse_1', 'Ringgroesse_2', 'Preis_Paar'].forEach(function (k) {
        d(details, labels[k], field(form, k, 40));
      });
      d(termin, '', field(form, 'Wunschtermin', 40));
      d(termin, 'Hochzeit', field(form, 'Hochzeit', 20));
      d(nachricht, 'Gravur 1', field(form, 'Gravur_1', 40));
      d(nachricht, 'Gravur 2', field(form, 'Gravur_2', 40));
    }
    d(nachricht, '', field(form, 'body', 300) || field(form, 'message', 300));
    return {
      art: kind,
      seite: location.pathname.slice(0, 80),
      name: field(form, 'name', 60),
      telefon: field(form, 'phone', 30),
      email: field(form, 'email', 100),
      termin: termin.join(' · '),
      produkt: kind === 'produkt' ? (field(form, 'product_url', 200) || field(form, 'ProductURL', 200) || location.pathname) : '',
      details: details.join(' · '),
      nachricht: nachricht.join(' · ')
    };
  }
  function track(kind) { return tracking.contact('whatsapp'); }
  function trackDirekt(kind, data, form) {
    var check = form.querySelector('[name="kontakt_abgleich"]');
    var match = tracking.marketing() && data.einwilligung.marketing && data.kontakt_abgleich && check && check.checked;
    var user = null;
    if (match) {
      user = {};
      var mail = (data.email || '').toLowerCase();
      var phone = (data.telefon || '').replace(/[^0-9+]/g, '');
      if (phone.indexOf('00') === 0) phone = '+' + phone.slice(2);
      else if (phone.indexOf('0') === 0) phone = '+49' + phone.slice(1);
      else if (phone && phone.charAt(0) !== '+') phone = '+' + phone;
      if (/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/.test(mail)) user.email = mail;
      if (/^\+[1-9][0-9]{7,14}$/.test(phone)) user.phone_number = phone;
      if (!Object.keys(user).length) user = null;
    }
    data.datalayer = { jb_anfrage_typ: kind, jb_kontaktweg: 'formular', kontakt_abgleich: !!user, user_data: user };
    tracking.emit('jb_form_submit_success', data);
    window.dataLayer.push({ user_data: null, kontakt_abgleich: false });
    data.datalayer = { jb_anfrage_typ: kind, jb_kontaktweg: 'formular' };
    tracking.emit('jb_anfrage_direkt', data);
    if (kind === 'verlobung') tracking.emit('jb_verlobung_anfrage', data);
    if (kind === 'trauring') tracking.emit('jb_konfigurator_anfrage', data);
  }
  function chatUrl(form, kind, data) {
    var text = form ? message(form, kind) : 'Hallo Juwelier Benjamin, ich möchte eine Anfrage stellen.';
    if (data && tracking.marketing()) text += '\n(Anfrage ' + data.anfrage_id + ')';
    return 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(text);
  }
  function chatOeffnen(url) {
    var opened = window.open(url, '_blank');
    if (opened) {
      try { opened.opener = null; } catch (ignore) {}
    } else {
      window.location.assign(url);
    }
  }
  function chatLink(kind, text) {
    var a = document.createElement('a');
    a.href = 'https://wa.me/' + WA_NUMBER;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.setAttribute('data-jb-wa-chat', kind);
    a.textContent = text;
    return a;
  }
  function stil() {
    if (document.getElementById('jb-direkt-stil')) return;
    var s = document.createElement('style');
    s.id = 'jb-direkt-stil';
    s.textContent = '.jb-direkt-form{display:grid;gap:10px;margin:0 0 18px}.jb-direkt-form label{display:grid;gap:4px;font-weight:600}' +
      '.jb-direkt-form input,.jb-direkt-form textarea{width:100%;font:inherit;padding:10px 12px;border:1px solid #c9c9d1;border-radius:8px;background:#fff}' +
      '[data-jb-direkt-status]{margin:10px 0 0;padding:12px 14px;border-radius:10px;background:#eef7ef;color:#16351c;font-weight:600}' +
      '[data-jb-direkt-status].jb-direkt-fehler{background:#fff4e5;color:#4a2b00}[data-jb-direkt-status] a{display:inline-block;margin-top:6px;text-decoration:underline}' +
      '.jb-abgleich{padding:12px;border:1px solid #ccc;border-radius:8px;margin:12px 0;font-size:14px}.jb-abgleich[hidden]{display:none!important}.jb-abgleich label{display:flex!important;gap:8px;align-items:flex-start}.jb-abgleich input{width:auto!important;flex:none;margin-top:4px}.jb-datenschutz-hinweis{font-size:12px;line-height:1.5;font-weight:400}.jb-direkt-hp{position:absolute!important;left:-9999px!important;width:1px;height:1px;opacity:0;pointer-events:none}';
    document.head.appendChild(s);
  }
  // Kontaktseite: bisher nur ein WhatsApp-Link. Davor ein kurzes Formular fuer Name, Telefon und Anliegen.
  function kontaktFormular(link) {
    var wrap = link.parentNode;
    if (!wrap || wrap.querySelector('.jb-direkt-form')) return null;
    stil();
    var form = document.createElement('form');
    form.className = 'jb-direkt-form';
    form.setAttribute('data-jb-wa-only', '');
    form.setAttribute('novalidate', '');
    var felder = [
      ['name', 'Name *', 'input', 'text', 'name', 100],
      ['phone', 'Telefon *', 'input', 'tel', 'tel', 40],
      ['message', 'Ihr Anliegen *', 'textarea', '', '', 1000]
    ];
    felder.forEach(function (f) {
      var label = document.createElement('label');
      label.textContent = f[1];
      var el = document.createElement(f[2]);
      el.name = 'contact[' + f[0] + ']';
      el.required = true;
      el.maxLength = f[5];
      if (f[3]) el.type = f[3];
      if (f[4]) el.autocomplete = f[4];
      if (f[2] === 'textarea') el.rows = 3;
      label.appendChild(el);
      form.appendChild(label);
    });
    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = link.className;
    knopf.setAttribute('data-jb-wa-kind', 'kontakt');
    form.appendChild(knopf);
    var alt = link.nextElementSibling;
    wrap.insertBefore(form, link);
    if (alt && alt.tagName === 'P' && /Senden/.test(alt.textContent)) {
      alt.textContent = 'Oder schreiben Sie uns selbst per WhatsApp: Der Chat öffnet sich mit einer vorbereiteten Nachricht, bitte dort auf „Senden“ tippen.';
    }
    link.textContent = 'Lieber selbst per WhatsApp schreiben';
    return knopf;
  }
  function vorbereiten(button) {
    var kind = button.getAttribute('data-jb-wa-kind');
    if (!DIREKT[kind] || button.hasAttribute('data-jb-direkt')) return;
    var form = button.closest('form');
    if (!form) {
      if (kind !== 'kontakt' || button.tagName !== 'A') return;
      button = kontaktFormular(button);
      if (!button) return;
      form = button.closest('form');
    }
    stil();
    button.setAttribute('data-jb-direkt', '');
    button.textContent = DIREKT[kind];
    if (!form.querySelector('[name="jb_hp"]')) {
      var hp = document.createElement('input');
      hp.type = 'text';
      hp.name = 'jb_hp';
      hp.tabIndex = -1;
      hp.autocomplete = 'off';
      hp.className = 'jb-direkt-hp';
      hp.setAttribute('aria-hidden', 'true');
      form.appendChild(hp);
    }
    var hinweis = null;
    Array.prototype.forEach.call(form.querySelectorAll('p'), function (p) {
      if (!hinweis && /Bitte dort auf/.test(p.textContent)) hinweis = p;
    });
    if (!hinweis) {
      hinweis = document.createElement('p');
      button.insertAdjacentElement('afterend', hinweis);
    }
    hinweis.textContent = HINWEIS[kind] + ' ';
    hinweis.appendChild(document.createTextNode('Wenn Sie Marketing erlaubt haben, ordnen wir Ihre Anfrage der Anzeige zu, über die Sie gekommen sind, und melden Google und Meta die Anfrage und einen späteren Online-Kauf, ohne Ihren Namen und Ihre Nachricht. Mehr in der '));
    hinweis.appendChild(datenschutzLink()); hinweis.appendChild(document.createTextNode('. '));
    abgleichFormular(form, button);
    // Auf der Kontaktseite steht der WhatsApp-Link schon direkt unter dem Formular.
    if (!form.classList.contains('jb-direkt-form')) hinweis.appendChild(chatLink(kind, 'Lieber selbst per WhatsApp schreiben'));
  }
  function ergebnis(form, button, kind, ok) {
    var el = box(button, 'data-jb-direkt-status', ok ? 'status' : 'alert');
    el.className = ok ? '' : 'jb-direkt-fehler';
    el.textContent = '';
    if (ok) {
      el.textContent = 'Danke! Ihre Anfrage ist direkt bei Juwelier Benjamin angekommen.' + (DANKE[kind] || '');
      // style statt hidden: Theme-Klassen setzen display und wuerden das hidden-Attribut ueberstimmen
      button.style.display = 'none';
    } else {
      el.appendChild(document.createTextNode('Die Direktanfrage hat gerade nicht geklappt. Bitte senden Sie sie per WhatsApp: '));
      el.appendChild(chatLink(kind, 'WhatsApp mit Ihrer Anfrage öffnen'));
    }
  }
  function datenschutzLink() {
    var a = document.createElement('a'); a.href = '/policies/privacy-policy'; a.textContent = 'Datenschutzerklärung'; return a;
  }
  function abgleichFormular(form, button) {
    if (form.querySelector('.jb-abgleich')) return;
    var wrap = document.createElement('div'); wrap.className = 'jb-abgleich';
    var label = document.createElement('label'), check = document.createElement('input');
    check.type = 'checkbox'; check.name = 'kontakt_abgleich'; check.value = 'ja'; check.checked = false;
    label.appendChild(check);
    label.appendChild(document.createTextNode('Ja, meine E-Mail-Adresse und Telefonnummer dürfen als Prüfwert (Hash) an Google und Meta gehen, damit Juwelier Benjamin den Erfolg seiner Werbung messen kann. (freiwillig)'));
    wrap.appendChild(label);
    var hint = document.createElement('p'); hint.className = 'jb-datenschutz-hinweis';
    hint.appendChild(document.createTextNode('Google und Meta gleichen den Prüfwert mit ihren Nutzerkonten ab, auch in den USA. Wir prüfen damit bis zu 60 Tage, ob Sie nach der Anfrage online bestellt haben. Ohne Häkchen bearbeiten wir Ihre Anfrage genauso. Widerruf jederzeit per E-Mail an wilhelm@juwelier-benjamin-shop.de. Mehr in der '));
    hint.appendChild(datenschutzLink()); hint.appendChild(document.createTextNode('.')); wrap.appendChild(hint);
    button.insertAdjacentElement('beforebegin', wrap); wrap.hidden = !tracking.marketing();
  }
  function consentUi() {
    document.querySelectorAll('.jb-abgleich').forEach(function (wrap) {
      wrap.hidden = !tracking.marketing(); if (wrap.hidden) wrap.querySelector('input').checked = false;
    });
    document.querySelectorAll('[data-jb-whatsapp-hinweis]').forEach(function (p) { p.hidden = !tracking.marketing(); });
  }
  function senden(form, button, kind) {
    if (button.getAttribute('aria-busy') === 'true') return;
    var state = vorgaenge.get(form); if (state && state.gesendet) return;
    var daten = state ? Object.assign({}, state.nutzdaten) : anfrage(form, kind), ctx = tracking.context('lead', state && state.kontext);
    if (!state) { state = { kontext: ctx, nutzdaten: Object.assign({}, daten), gesendet: false }; vorgaenge.set(form, state); }
    Object.assign(daten, ctx);
    var hp = form.querySelector('[name="jb_hp"]'), check = form.querySelector('[name="kontakt_abgleich"]');
    daten.kontakt_abgleich = !!(ctx.einwilligung.marketing && tracking.marketing() && check && check.checked);
    daten.kontakt_abgleich_am = daten.kontakt_abgleich ? new Date().toISOString() : null;
    daten.kontakt_abgleich_version = 'haekchen-2026-10-24-v1';
    daten.id = daten.event_id; daten.hp = hp ? hp.value : ''; daten.ms = Date.now() - START;
    var beschriftung = button.textContent, fertig = false;
    var abbruch = window.AbortController ? new AbortController() : null;
    button.setAttribute('aria-busy', 'true'); button.textContent = 'Wird gesendet …';
    function ende(status) {
      if (fertig) return; fertig = true; clearTimeout(uhr);
      button.removeAttribute('aria-busy'); button.textContent = beschriftung;
      var ok = status === 'gesendet' || status === 'doppelt_gesendet';
      if (status === 'fehler') vorgaenge.delete(form);
      if (ok && !state.gesendet) { state.gesendet = true; trackDirekt(kind, daten, form); }
      if (status === 'in_arbeit' || status === 'unklar') {
        var el = box(button, 'data-jb-direkt-status', 'status');
        el.textContent = status === 'in_arbeit' ? 'Ihre Anfrage wird noch verarbeitet. Bitte warten Sie kurz und prüfen Sie den Status mit demselben Knopf.' : 'Der Versandstatus ist noch unklar. Bitte prüfen Sie ihn mit demselben Knopf. Ihre Anfrage wird dabei nicht doppelt gesendet.';
      } else ergebnis(form, button, kind, ok);
    }
    var uhr = setTimeout(function () { if (abbruch) abbruch.abort(); ende('unklar'); }, 10000);
    try {
      fetch(ZIEL, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(daten), credentials: 'omit', signal: abbruch ? abbruch.signal : undefined })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, http: r.status, body: j }; }); })
        .then(function (r) {
          var j = r.body;
          if (j && j.status === 'in_arbeit') ende('in_arbeit');
          else if (r.http >= 500 || r.http === 429) ende('unklar');
          else if (r.ok && j && j.ok === true && (j.status === 'gesendet' || j.status === 'doppelt_gesendet')) ende(j.status);
          else if ((r.http >= 400 && r.http < 500 && r.http !== 409) || (r.ok && j && j.ok === false && j.status === 'fehler')) ende('fehler');
          else ende('unklar');
        }).catch(function () { ende('unklar'); });
    } catch (e) { ende('unklar'); }
  }
  function kontaktHinweise() {
    document.querySelectorAll('a[href^="tel:"],a[href*="wa.me/"],[data-jb-wa-chat]').forEach(function (a) {
      var phone = a.getAttribute('href').indexOf('tel:') === 0;
      var container = a.closest('form,.jbv-kontakt,.jb-konf__schnell') || document.querySelector('footer');
      var attr = phone ? 'data-jb-telefon-hinweis' : 'data-jb-whatsapp-hinweis';
      if (!container) return;
      // Die Kontaktknöpfe des Konfigurators bleiben allein in ihrer Flex-Zeile.
      if (container.matches('.jb-konf__schnell')) {
        var notes = container.nextElementSibling;
        if (!notes || !notes.hasAttribute('data-jb-kontakt-hinweise')) {
          notes = document.createElement('div'); notes.setAttribute('data-jb-kontakt-hinweise', '');
          container.insertAdjacentElement('afterend', notes);
        }
        container = notes;
      }
      if (container.querySelector('[' + attr + ']')) return;
      var p = document.createElement('p'); p.className = 'jb-datenschutz-hinweis'; p.setAttribute(attr, '');
      p.textContent = phone ? 'Mit Ihrer Einwilligung zählen wir Klicks auf diesen Knopf. Gespräche werden nicht aufgezeichnet. Mehr in der ' : 'Am Ende des Textes steht eine Anfrage-Nummer. Sie hilft uns, Ihre Nachricht der Anzeige zuzuordnen. Sie können sie vor dem Senden löschen.';
      if (phone) { p.appendChild(datenschutzLink()); p.appendChild(document.createTextNode('.')); } else p.hidden = !tracking.marketing();
      container.appendChild(p);
    });
  }
  function alleVorbereiten() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-jb-wa-kind]'), vorbereiten);
    kontaktHinweise(); consentUi();
  }
  document.addEventListener('submit', function (event) {
    if (!event.target.matches || !event.target.matches('form[data-jb-wa-only]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var button = event.target.querySelector('[data-jb-wa-kind]'); if (button) button.click();
  }, true);
  document.addEventListener('click', function (event) {
    var chat = event.target.closest('[data-jb-wa-chat],a[href*="wa.me/"]:not([data-jb-wa-kind])');
    if (chat) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var chatKind = chat.getAttribute('data-jb-wa-chat') || 'kontakt', data = track(chatKind), url;
      if (chat.hasAttribute('data-jb-wa-chat')) url = chatUrl(chat.closest('form'), chatKind, data);
      else {
        url = new URL(chat.href);
        if (data) url.searchParams.set('text', (url.searchParams.get('text') || 'Hallo Juwelier Benjamin, ich möchte eine Anfrage stellen.') + '\n(Anfrage ' + data.anfrage_id + ')');
        url = url.href;
      }
      chatOeffnen(url);
      return;
    }
    var button = event.target.closest('[data-jb-wa-kind]');
    if (!button) return;
    var form = button.closest('form'), kind = button.getAttribute('data-jb-wa-kind');
    if (kind === 'kontakt' && !form && button.tagName === 'A') {
      track(kind);
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!form || ARTEN.indexOf(kind) < 0) return;
    if (form.hasAttribute && form.hasAttribute('data-jb-wa-only') && !form.classList.contains('jb-direkt-form') &&
        typeof form.checkValidity === 'function' && !form.checkValidity()) {
      if (typeof form.reportValidity === 'function') form.reportValidity();
      return;
    }
    if (kind === 'verlobung' || kind === 'trauring' || form.classList.contains('jb-direkt-form')) {
      if (!requireField(form, button, 'name', 'Bitte geben Sie Ihren Namen ein.')) return;
      if (!requireField(form, button, 'phone', 'Bitte geben Sie Ihre Telefonnummer ein.')) return;
    }
    if (kind === 'trauring' && !requireField(form, button, 'Modell', 'Bitte wählen Sie zuerst ein Trauring-Modell.')) return;
    if (kind === 'kontakt' && !requireField(form, button, 'message', 'Bitte schreiben Sie kurz, worum es geht.')) return;
    if (kind === 'produkt') {
      if (!requireField(form, button, 'name', 'Bitte geben Sie Ihren Namen ein.')) return;
      if (!requireField(form, button, 'body', 'Bitte schreiben Sie Ihre Produktfrage.')) return;
    }
    var fehlerBox = button.parentNode.querySelector('[data-jb-wa-error]');
    if (fehlerBox) fehlerBox.hidden = true;
    // Direkt ans Ladenhandy nur mit Rueckrufweg (Telefon oder E-Mail), sonst wie bisher der Chat.
    if (button.hasAttribute('data-jb-direkt') && (field(form, 'phone') || field(form, 'email'))) {
      senden(form, button, kind);
      return;
    }
    var data = track(kind);
    chatOeffnen(chatUrl(form, kind, data));
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alleVorbereiten);
  else alleVorbereiten();
  document.addEventListener('shopify:section:load', alleVorbereiten);
  document.addEventListener('jb:consent', consentUi);
})();
